import { render } from "preact";
import { debug } from "@/ts/utilities";
import { DEBUG_MODE, REACTIVE } from "@/ts/enums";

interface State {
    data: Record<string, any>
    queue: Record<string, any>
    bundles: string[]
}

const state: State = {
    data: {},
    queue: {},
    bundles: []
};

function collectBundles() {
    return Object.keys(
        [].slice.call(document.querySelectorAll(".reactive-component"))
            .reduce((bundles: Record<string, boolean>, $component: HTMLElement) => {
                if ($component) {
                    const bundle = $component.getAttribute("data-bundle");
                    if (bundle) {
                        bundles[bundle] = true;
                    }
                }
                return bundles;
            }, {})
    );
}

function loadModelByBundle(bundle: string) {

    return fetch(`${REACTIVE.ENDPOINT}/${bundle}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/vnd.api+json"
        }
    })
        .then((response) => {
            return response.json();
        })
        .then(response => {
            return response.data;
        });
}

function subscribeToBundle(bundle: string, uuid: string, fn: Function) {
    state.queue[bundle] = state.queue[bundle] || [];
    state.queue[bundle].push(() => {
        const model = state.data[bundle].find((dm: any) => dm.id === uuid) || {};
        fn(model);
    })
}

function flushBundleQueue (bundle: string) {
    if(state.queue[bundle]) {
        state.queue[bundle].forEach((queueItem: Function) => {
            queueItem();
        });
        state.queue[bundle] = [];
    }
}

export function initDataModels() {
    state.bundles = collectBundles();
    state.bundles.forEach((bundle) => {
        loadModelByBundle(bundle)
            .then((res) => {
                state.data[bundle] = res;
                flushBundleQueue(bundle);
            });
    });
}

export function hydrate(component: any, $targets: HTMLElement[] | string, append = false) {

    const $nodes = typeof $targets === "string" ? document.querySelectorAll($targets) : $targets as HTMLElement[];
    $nodes.forEach(($node) => {
        const $injector = $node.querySelector("[data-reactive-injector]")!;
        if ($injector) {
            const uuid = $node.getAttribute("data-uuid")!;
            const bundle = $node.getAttribute("data-bundle")!;
            const model = $node.getAttribute("data-remote-model")!;

            if(model) {
                subscribeToBundle(bundle, uuid, (model: object) => {
                    component.props = {
                        ...component.props,
                        ...model,
                    };
                    if (!append) {
                        $injector.innerHTML = "";
                    }
                    render(component, $injector);
                    debug(`Component ${uuid} of type "${bundle}" hydrated with data model.`);
                });
            } else {
                if (!append) {
                    $injector.innerHTML = "";
                    render(component, $injector);
                    debug(`Component ${uuid} of type "${bundle}" hydrated.`);
                }
            }

        } else {
            debug(`Failed to hydrate component "${component?.type?.name}". Missing injector`, DEBUG_MODE.WARNING);
        }
    });

}